import React from "react";
import VideoBlogLayout from "../../components/VideoBlogLayout";

const BlogSarahDenialManagement = () => (
  <VideoBlogLayout
    category="Video Demo"
    eyebrow="AI-Powered Denial Management"
    title="Let me guess: your staff spent hours this week fighting denials"
    subtitle="Watch Sarah work a complex denial end-to-end — reading benefits, clinical history, and prior claims, then drafting the appeal so your team reviews instead of writing from scratch."
    author="Asha Team"
    date="May 23, 2026"
    readTime="5 min watch"
    videoUrl="https://www.loom.com/embed/4d43737293af43febc9820416a075f00"
    videoTitle="Asha's AI Automatically Fights Denials"
    videoProvider="loom"
  >
    <div className="space-y-14">
      <div>
        <p className="text-lg text-gray-600 leading-relaxed mb-4">
          Complex denials usually mean someone digging through claims, payment
          history, benefits, attachments, and clinical notes just to decide
          whether this is an appeal, a corrected claim, a resubmission, or a
          write-off.
        </p>
        <p className="text-lg text-gray-600 leading-relaxed">
          Whereas this might take your staff hours, Asha's AI Denial Management
          Agent — we call her{" "}
          <strong className="text-gray-900 font-semibold">Sarah</strong> — can
          do it in a matter of seconds. Sarah isn't just a blanket AI that
          answers your questions. She works autonomously in the background,
          reading information from your PMS (benefits info, clinical history,
          etc.), reasoning, then taking action.
        </p>
      </div>

      <div>
        <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-4 tracking-tight">
          How Sarah works a denial
        </h2>
        <ul className="space-y-3 text-lg text-gray-600 leading-relaxed">
          <li className="flex gap-3">
            <span className="text-blue-600 mt-1.5 flex-shrink-0">•</span>
            <span>
              Automatically processes ERAs and EOBs as they arrive — reducing
              manual entry and document sorting.
            </span>
          </li>
          <li className="flex gap-3">
            <span className="text-blue-600 mt-1.5 flex-shrink-0">•</span>
            <span>
              Iteratively reviews patient history, pre-auths, installment
              records, ledger accuracy, and prior claims until the cause is
              clear.
            </span>
          </li>
          <li className="flex gap-3">
            <span className="text-blue-600 mt-1.5 flex-shrink-0">•</span>
            <span>
              Drafts appeal language or corrective next steps so your team
              reviews instead of writing from scratch.
            </span>
          </li>
          <li className="flex gap-3">
            <span className="text-blue-600 mt-1.5 flex-shrink-0">•</span>
            <span>
              Flags only the exceptions when she isn't fully confident, with
              full context attached.
            </span>
          </li>
        </ul>
      </div>

      <div className="rounded-2xl border border-blue-100 bg-blue-50/60 p-6">
        <h3 className="text-lg font-bold text-blue-900 mb-2">
          20+ AI Products in 1 Platform
        </h3>
        <p className="text-base text-gray-700 leading-relaxed">
          Sarah is just 1 of 20 AI products + 10 softwares in the Asha Dental
          AI OS. While she's impressive alone, the real magic is how she works
          with her dozens of other AI teammates to run your office.
        </p>
      </div>

      <div>
        <p className="text-lg text-gray-600 leading-relaxed">
          When the team is only handling exceptions, the revenue cycle stops
          being firefighting and starts being a system.
        </p>
      </div>
    </div>
  </VideoBlogLayout>
);

export default BlogSarahDenialManagement;
